import { Client, SessionData } from '@chegg/rio-sdk-web'
import * as _globalize from '@chegg/rio-sdk-web/lib/src/globalizeApi'
import * as Sentry from '@sentry/browser'
import { Target } from 'redux-beacon'
import { EventWithConfig } from './types'
import { rioEvent } from './rsw'

const wtaAnalytics = (): Target => (events: EventWithConfig[]) => {
  if (typeof window === 'undefined') {
    return
  }

  events.forEach(({ payload, config }: EventWithConfig) => {
    if (typeof payload === 'object') {
      rioEvent(payload, config).catch(e => Sentry.captureException(e))
    }
  })
}

export const initializeWtaClient = (options: SessionData) => {
  window.wtaCmd = window.wtaCmd || []
  const callback = (client: Client) => {
    client.init(options)
  }
  window.wtaCmd.push(callback)
}

export default wtaAnalytics
